import React from 'react';
import {Stack} from '@mui/material';
import {Icon} from '@lightricks/react-design-system';
import {styled} from '@mui/material/styles';
import {ModalTitleProps} from './ModalTitleProps';

import CloseModalIcon from '@/components/icons/CloseModal';
import styles from './ModalTitle.module.scss';

const StyledStack = styled(Stack)({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
});

function ModalTitle(props: ModalTitleProps) {
  const {onCloseButtonClick, title} = props;
  return (
    <StyledStack className={styles.root}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Icon size="medium" appearance="neutral" name="Features-Edit-Full" />
        <span className={styles.title}>{title}</span>
      </div>
      <div
        id="close_icon"
        role="presentation"
        className={styles.close}
        style={{marginTop: '0'}}
        onClick={onCloseButtonClick}
        onKeyDown={onCloseButtonClick}
      >
        <CloseModalIcon />
      </div>
    </StyledStack>
  );
}

export default ModalTitle;
